const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ data }) => {
  const detailsRows = data.details || [];
  const currentAdvanceDocs = data.currentAdvanceDocs || [];
  const spentDocs = data.spentDocs || [];

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Giấy Thanh Toán Tiền Tạm Ứng</title>
      <style>
        @media print { @page { margin: 10mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 15px; color: #000; padding: 18px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .right { text-align:center; line-height: 1.25; }
        .title { margin: 12px 0 4px; text-align:center; font-size: 26px; font-weight: 700; text-transform: uppercase; }
        .date { text-align:center; margin-bottom: 8px; font-style: italic; }
        .meta-right { text-align:right; line-height: 1.6; }
        .row { margin-top: 6px; }
        table { width: 100%; border-collapse: collapse; margin-top: 6px; }
        th, td { border: 1px solid #000; padding: 6px; }
        .signatures { display:flex; justify-content:space-between; text-align:center; margin-top: 28px; }
        .sign-col { width: 24%; }
        .sign-spacer { height: 56px; }
        .italic { font-style: italic; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${escapeHtml(data.unit || "")}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(data.department || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số 04 - TT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">GIẤY THANH TOÁN TIỀN TẠM ỨNG</div>
      <div class="date">Ngày ${escapeHtml(data.documentDate || ".../.../....")}</div>

      <div class="meta-right">
        <div>Số: ${escapeHtml(data.documentNumber || "")}</div>
        <div>Nợ: ${escapeHtml(data.debitAccount || "")}</div>
        <div>Có: ${escapeHtml(data.creditAccount || "")}</div>
      </div>

      <div class="row">- Họ và tên người thanh toán: ${escapeHtml(data.payerName || "")}</div>
      <div class="row">- Bộ phận (hoặc địa chỉ): ${escapeHtml(data.payerDepartmentAddress || "")}</div>
      <div class="row">- Số tiền tạm ứng được thanh toán theo bảng dưới đây:</div>

      <table>
        <thead>
          <tr>
            <th>Diễn giải</th>
            <th style="width:30%">Số tiền</th>
          </tr>
        </thead>
        <tbody>
          ${detailsRows
            .map(
              (row) => `
            <tr>
              <td>${escapeHtml(row.description || "")}</td>
              <td style="text-align:right">${fmtMoney(row.amount || 0)}</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      </table>

      <table>
        <thead>
          <tr>
            <th>A</th>
            <th style="width:30%">1</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><b>I. Số tiền tạm ứng</b></td>
            <td style="text-align:right">${fmtMoney(data.totalAdvance || 0)}</td>
          </tr>
          <tr>
            <td>1. Số tạm ứng các kỳ trước chưa chi hết</td>
            <td style="text-align:right">${fmtMoney(data.previousUnspent || 0)}</td>
          </tr>
          <tr>
            <td>2. Số tạm ứng kỳ này</td>
            <td style="text-align:right">${fmtMoney((data.totalAdvance || 0) - (data.previousUnspent || 0))}</td>
          </tr>
          ${currentAdvanceDocs
            .map(
              (row) => `
            <tr>
              <td>- Phiếu chi số ${escapeHtml(row.documentNumber || "")} ngày ${escapeHtml(
                row.documentDate || ""
              )}</td>
              <td style="text-align:right">${fmtMoney(row.amount || 0)}</td>
            </tr>
          `
            )
            .join("")}
          <tr>
            <td><b>II. Số tiền đã chi</b></td>
            <td style="text-align:right">${fmtMoney(data.totalSpent || 0)}</td>
          </tr>
          ${spentDocs
            .map(
              (row, idx) => `
            <tr>
              <td>${idx + 1}. Chứng từ số ${escapeHtml(row.documentNumber || "")} ngày ${escapeHtml(
                row.documentDate || ""
              )}</td>
              <td style="text-align:right">${fmtMoney(row.amount || 0)}</td>
            </tr>
          `
            )
            .join("")}
          <tr>
            <td><b>III. Chênh lệch</b></td>
            <td></td>
          </tr>
          <tr>
            <td>1. Số tạm ứng chi không hết (I - II)</td>
            <td style="text-align:right">${fmtMoney(data.diffUnspent || 0)}</td>
          </tr>
          <tr>
            <td>2. Chi quá số tạm ứng (II - I)</td>
            <td style="text-align:right">${fmtMoney(data.diffOverspent || 0)}</td>
          </tr>
        </tbody>
      </table>

      <div class="signatures">
        <div class="sign-col">
          <div><b>Giám đốc</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
        <div class="sign-col">
          <div><b>Kế toán trưởng</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
        <div class="sign-col">
          <div><b>Kế toán thanh toán</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
        <div class="sign-col">
          <div><b>Người đề nghị thanh toán</b></div>
          <div class="italic">(Ký, họ tên)</div>
          <div class="sign-spacer"></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>`;
};
